exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.school-col[data-v-f9a2e9c4]{\n    min-width:420px;\n    max-width:520px;\n    white-space:nowrap;\n}\n", ""]);

// exports
